import React from 'react'
import { Container } from '@material-ui/core'
import { useStyles } from './Footer.styles'
import { FooterListGroup } from '../FooterList'
import { FooterLinks } from '../FooterLinks'
import { IMenuItem } from '../../../../hooks/useMenu'
import { List } from 'immutable'

interface IFooter {
  footerItems: List<IMenuItem>
}

const Footer = ({ footerItems }: IFooter) => {
  const classes = useStyles()

  return (
    <div className={classes.footer}>
      <Container maxWidth="xl" component="footer">
        <FooterListGroup footerItems={footerItems} />
        <FooterLinks />
      </Container>
    </div>
  )
}

export default Footer
